import React from "react";
import PropTypes from "prop-types";

import MuiAlert from "@mui/material/Alert";

import WarningIcon from "assets/svg/warning.svg";
import InfoIcon from "assets/svg/info-icon.svg";
import TickIcon from "assets/svg/tick.svg";

export default function Alert(props) {
  const { severity, text, variant = "filled" } = props;

  return (
    <MuiAlert
      iconMapping={{
        success: <TickIcon width="20px" fontSize="inherit" />,
        info: <InfoIcon width="20px" fontSize="inherit" />,
        warning: <WarningIcon width="20px" fontSize="inherit" />,
        error: <WarningIcon width="20px" fontSize="inherit" />,
      }}
      severity={severity}
      variant={variant}
    >
      {text}
    </MuiAlert>
  );
}

Alert.propTypes = {
  severity: PropTypes.oneOf(["success", "info", "warning", "error"]),
  variant: PropTypes.oneOf(["filled", "outlined", "standard"]),
  text: PropTypes.string,
};
